import ServiceBase from './ServiceBase'

export default class Request extends ServiceBase {
  constructor() {
    //console.log('---request---');
    super()
  }
}
